import styled from 'styled-components';
import { InternalLinks } from '../../../components/Toolkit/InternalLinks/InternalLinks';
import { QuickFilters } from '../../../components/SearchPage/features/QuickFilters/QuickFilters';
import { donedealBreakpoints } from 'styled-system';

export const Header = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.S8};

  ${donedealBreakpoints.media.large} {
    margin-bottom: ${({ theme }) => theme.spacing.M32};
  }
`;

export const HeaderDivider = styled.div`
  display: flex;
  flex-direction: column;

  ${donedealBreakpoints.media.large} {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
  }
`;

export const HeaderTitle = styled.h1`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 0 1 auto;
  ${({ theme }) => theme.donedeal.fontSize.L18};
  margin-right: ${({ theme }) => theme.spacing.M16};

  ${donedealBreakpoints.media.large} {
    ${({ theme }) => theme.donedeal.fontSize.H32};
  }
`;

export const HeaderSearch = styled.div`
  flex: 1 0 auto;
  order: -1;
  margin-bottom: ${({ theme }) => theme.spacing.M16};

  ${donedealBreakpoints.media.large} {
    order: 1;
    max-width: 456px;
    min-width: 300px;
    margin-bottom: 0;
  }
`;

export const HeaderSections = styled.div`
  order: -1;
  margin-bottom: ${({ theme }) => theme.spacing.S12};
  ${donedealBreakpoints.media.large} {
    display: none;
  }
`;

export const Container = styled.div`
  background: ${({ theme }) => theme.donedeal.colors.OFFWHITE};
`;

export const Main = styled.div`
  display: block;

  ${donedealBreakpoints.media.large} {
    display: grid;
    grid-template-columns: 320px 1fr;
    grid-gap: ${({ theme }) => theme.spacing.L40};
  }
`;

export const Sidebar = styled.div`
  display: none;
  padding-bottom: ${({ theme }) => theme.spacing.M16};

  ${donedealBreakpoints.media.large} {
    display: block;
  }
`;

export const SidebarAdUnit = styled.div`
  position: sticky;
  top: ${({ theme }) => theme.spacing.M16};
`;

export const Body = styled.div`
  padding-bottom: ${({ theme }) => theme.spacing.M16};
`;

// TODO: Think of a better name
export const DetailsAndToggles = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.S8};
  margin-bottom: ${({ theme }) => theme.spacing.M24};
`;

export const Details = styled.h2`
  flex: 1 1 auto;
  ${({ theme }) => theme.donedeal.fontSize.M16};
  font-weight: normal;
  word-break: break-word;
`;

export const Toggles = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.S8};
  flex: 0 0 auto;
`;

export const Pagination = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.M24};
`;

export const InternalTagsPanel = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.M24};
`;

export const InternalTagsTitle = styled.h2`
  margin-bottom: ${({ theme }) => theme.spacing.M16};
  ${({ theme }) => theme.donedeal.fontSize.B18};
`;

export const DFPUnitContainer_Top = styled.div`
  display: none;

  ${donedealBreakpoints.media.large} {
    display: block;
    margin-bottom: ${({ theme }) => theme.spacing.M16};
  }
`;

export const Spacer = styled.div`
  min-height: 4px;
  margin-bottom: ${({ theme }) => theme.spacing.M16};
`;

export const SInternalLinks = styled(InternalLinks)`
  background-color: ${({ theme }) => theme.donedeal.colors.OFFWHITE};
  padding: ${({ theme }) => theme.spacing.M16};

  ${donedealBreakpoints.media.medium} {
    padding: ${({ theme }) => theme.spacing.M24} 0;
  }
`;

export const InternalLinksContainer = styled.div<{ isWhite: boolean }>`
  background-color: ${({ theme, isWhite }) =>
    isWhite ? theme.donedeal.colors.WHITE : theme.donedeal.colors.OFFWHITE};
  ${SInternalLinks} {
    background-color: ${({ theme, isWhite }) =>
      isWhite ? theme.donedeal.colors.WHITE : theme.donedeal.colors.OFFWHITE};
  }
`;

export const BuyingCarTipsContainer = styled.div`
  background-color: ${({ theme }) => theme.donedeal.colors.WHITE};
  padding: ${({ theme }) => theme.spacing.M16};

  ${donedealBreakpoints.media.large} {
    padding: ${({ theme }) => `${theme.spacing.M32} 0`};
  }
`;

export const MobileQuickFilters = styled(QuickFilters)`
  position: sticky;
  top: 0;
  z-index: 1000;
  background-color: ${({ theme }) => theme.donedeal.colors.OFFWHITE};
  padding: ${({ theme }) => theme.spacing.S8};

  ${donedealBreakpoints.media.large} {
    display: none;
  }
`;
